import { Component, HostListener, OnInit } from '@angular/core';
import { UserService } from './services/user.service';
import { NavigationStart, Router } from '@angular/router';

//export let browserRefresh = false;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  // constructor(
  //   public readonly userService: UserService,
  //   private router: Router
  // ) {
  //   this.router.events.subscribe((event) => {
  //     if (event instanceof NavigationStart) {
  //       browserRefresh = !router.navigated;
  //     }
  //   });
  // }

  // @HostListener('window:beforeunload', ['$event'])
  // beforeunload(event) {
  //     if (!browserRefresh) 
  //     { 
  //       this.userService.logout(''); 
  //     }
  // }

  ngOnInit() { 
  }


}
